// extracted by mini-css-extract-plugin
module.exports = {"head":"styles_head__2gTzL"};